import React from 'react';
import {
  Grid,
  Typography,
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  Divider,
  IconButton,
  Collapse,
} from '@mui/material';
import {
  Person,
  Bloodtype,
  LocalHospital,
  Warning,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const ResumenPaciente = ({ paciente }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const fechaNac = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edad--;
    }
    return edad;
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" component="div" color="primary" sx={{ display: 'flex', alignItems: 'center' }}>
          <Person sx={{ mr: 1 }} />
          Información del Paciente
        </Typography>
        <IconButton onClick={handleExpandClick}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" color="text.secondary">
            Nombre Completo
          </Typography>
          <Typography variant="body1">
            {`${paciente.nombre} ${paciente.apellidos}`}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" color="text.secondary">
            RUT
          </Typography>
          <Typography variant="body1">
            {paciente.rut}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" color="text.secondary">
            Edad
          </Typography>
          <Typography variant="body1">
            {calcularEdad(paciente.fechaNacimiento)} años
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Bloodtype color="error" />
            <Typography variant="body1">
              Grupo Sanguíneo: {paciente.grupoSanguineo || 'No especificado'}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Collapse in={expanded}>
        <Box sx={{ mt: 3 }}>
          <Divider sx={{ my: 2 }} />
          
          {paciente.alergias?.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" color="error" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Warning sx={{ mr: 1 }} />
                Alergias
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {paciente.alergias.map((alergia, index) => (
                  <Chip
                    key={index}
                    label={`${alergia.tipo}: ${alergia.descripcion}`}
                    color="error"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Box>
          )}

          {paciente.condicionesMedicas?.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" color="primary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <LocalHospital sx={{ mr: 1 }} />
                Condiciones Médicas
              </Typography>
              <List dense>
                {paciente.condicionesMedicas.map((condicion, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={condicion.condicion}
                      secondary={`Diagnóstico: ${format(new Date(condicion.fechaDiagnostico), 'PP', { locale: es })} - Tratamiento: ${condicion.tratamientoActual}`}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}

          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" color="text.secondary">
              Previsión de Salud
            </Typography>
            <Typography variant="body1">
              {paciente.previsionSalud?.tipo || 'No especificada'}
              {paciente.previsionSalud?.institucion && ` - ${paciente.previsionSalud.institucion}`}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" color="text.secondary">
              Contacto de Emergencia
            </Typography>
            <Typography variant="body1">
              {paciente.contactoEmergencia ? (
                <>
                  {paciente.contactoEmergencia.nombre} ({paciente.contactoEmergencia.relacion})
                  <br />
                  {paciente.contactoEmergencia.telefono}
                </>
              ) : (
                'No especificado'
              )}
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default ResumenPaciente; 